// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3ypqW","row":"styles_row__2FK6p","col":"styles_col__12Hg1","section_title":"styles_section_title__XeALZ","form_wrapper":"styles_form_wrapper__21O63"};